import { render } from "./ProjectPublicationsDayPicker.vue?vue&type=template&id=4a20cd1c"
import script from "./ProjectPublicationsDayPicker.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationsDayPicker.vue?vue&type=script&lang=js"

import "./ProjectPublicationsDayPicker.vue?vue&type=style&index=0&id=4a20cd1c&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__